/* eslint-disable @typescript-eslint/no-explicit-any */
import PostDetail from '@/components/BlogDetail'
import CategorySort from '@/components/Category/CategorySort'
import { ChildrenCategory } from '@/components/Category/ChildrenCategory'
import { FilterHighlight } from '@/components/Category/FilterHighlight'
import { Loading } from '@/components/Loading/Loading'
import NotFoundItem from '@/components/NotFound'
import ProductCard from '@/components/ProductCard'
import BundledProduct from '@/components/ProductDetail/BundledProduct'
import { EntrySummary } from '@/components/ProductDetail/EntrySummary'
import Promotion from '@/components/ProductDetail/EntrySummary/promotion'
import { Gallery } from '@/components/ProductDetail/Gallery'
import Information from '@/components/ProductDetail/Information'
import ProductDetailBreadcrumb from '@/components/ProductDetail/ProductDetailBreadcrumb'
import { RelatedProduct } from '@/components/ProductDetail/RelatedProduct'
import ReviewAndRate from '@/components/ProductDetail/ReviewAndRate'
import { BannerProductListing } from '@/components/ProductListing/BannerProductListing'
import ProductCardSkeleton from '@/components/Skeleton/ProductCardSkeleton'
import { PageType, ProductStockStatus } from '@/constants'
import { useAuth, useCart, useNotification, useStore } from '@/containers'
import { useCategory } from '@/hooks/useCategoryHook'
import { HeaderCategory } from '@/layouts/HeaderCategory'
import { HeaderProductDetail } from '@/layouts/HeaderProductDetail'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import type {
  GiftItems,
  Keywords,
  OtherOffers,
  Product,
  QueryParam,
} from '@/types'
import { type OrderService, type Property } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import {
  getBottomMenu,
  getCategory,
  getCategoryMenu,
  getConfig,
  getKeywordFooter,
  getMenus,
  getPageDetail,
  getPath,
  getSaleRegion,
} from '@/utils/endpoint'
import * as pixel from '@/utils/fpixel'
import { getPageTypeFromPath, stripHtmlTagsAndLimit } from '@/utils/next-util'
import { useIsomorphicLayoutEffect } from '@/utils/useIsomorphicLayoutEffect'
import { getCookies } from 'cookies-next'
import orderBy from 'lodash/orderBy'
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
const PopupShare = dynamic(() => import('@/components/Popup/PopupShare'), {
  ssr: false,
})
const FooterProductDetail = dynamic(
  () => import('@/components/ProductDetail/FooterProductDetail'),
  {
    ssr: false,
  }
)
const Specifications = dynamic(
  () => import('@/components/ProductDetail/Specifications'),
  {
    ssr: false,
  }
)
interface DynamicPageProps {
  pageDetail: any
  categoryDetail: any
  pageType: string
  hideMenu: string
  keywords: Keywords
}
const DynamicPage = ({
  pageDetail,
  categoryDetail,
  pageType,
  hideMenu,
}: DynamicPageProps) => {
  const router = useRouter()
  const specRef = useRef<HTMLDivElement>(null)
  const reviewRef = useRef<HTMLDivElement>(null)
  const descRef = useRef<HTMLDivElement>(null)
  const outStandingFeatureRef = useRef<HTMLDivElement>(null)
  const [checkSaleArea, setCheckSaleArea] = useState(true)
  const [listService, setListService] = useState<OrderService[]>([])
  const [listGift, setListGift] = useState<GiftItems[] | undefined>([])
  const [listOffer, setListOffer] = useState<OtherOffers[] | undefined>([])
  const [isOpenContact, setIsOpenContact] = useState(false)
  const [visibleHeader, setVisibleHeader] = useState(true)
  const [isOpenShare, setIsOpenShare] = useState(false)
  const [pickUpInStore, setPickUpInStore] = useState(false)
  const [priceWithService, setPriceWithService] = useState(0)
  const [listBundleSelected, setListBundleSelected] = useState<Product[]>([])
  useEffect(() => {
    setListBundleSelected([])
  }, [])
  const { channel } = useAuth()
  const { addToCart, cartLoading, isPreOrder, setIsPreOrder, addBundleToCart } =
    useCart()
  const {
    area,
    productCompares,
    setProductCompares,
    setIsOpenComparePopup,
    setProductViewed,
    setCatViewId,
  } = useStore()
  const productName = useMemo(() => {
    return getTranslate(pageDetail?.data?.name)
  }, [pageDetail])
  useEffect(() => {
    return () => {
      setProducts([])
      setCurrentPage(1)
    }
  }, [])
  useEffect(() => {
    return () => {
      setCurrentPage(1)
    }
  }, [categoryDetail])
  const executeScroll = (ref: {
    current: {
      scrollIntoView: (arg0: {
        behavior: string
        block: string
        inline: string
      }) => void
    }
  }) => {
    ref.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    })
  }
  const productDescription = useMemo(() => {
    return stripHtmlTagsAndLimit(
      getTranslate(pageDetail?.data?.description),
      160
    )
  }, [pageDetail])
  const pageShortDescription = useMemo(() => {
    return stripHtmlTagsAndLimit(
      getTranslate(pageDetail?.data?.shortDescription),
      160
    )
  }, [pageDetail])
  useEffect(() => {
    if (pageDetail?.data?.preOrder && pageType == PageType.PRODUCT) {
      return setIsPreOrder(true)
    }
    return setIsPreOrder(false)
  }, [pageDetail, pageType])
  useEffect(() => {
    if (pageDetail && pageDetail.data && pageType === PageType.PRODUCT) {
      const newListService = pageDetail.data.orderServices
        ?.sort((a: any, b: any) => a?.order - b?.order)
        ?.map((e: any) => {
          if (e) {
            return { ...e, active: false }
          }
          return null
        })
        ?.filter(Boolean)
      setListService(newListService)
    }
  }, [pageDetail, pageType, channel])
  useEffect(() => {
    if (pageDetail && pageType === PageType.PRODUCT) {
      setCatViewId(pageDetail.data.catId)
      setProductViewed(
        pageDetail.data.relatedProductIds.map((e: any) => ({
          _id: e,
        }))
      )
      const mergeData = pageDetail?.data?.gifts?.reduce(
        (result: any, item: any) => {
          result.otherOffers = (result.otherOffers || []).concat(
            item.otherOffers
          )
          result.giftItems = (result.giftItems || []).concat(item.giftItems)
          return result
        },
        {} as any
      )
      const gifts = mergeData?.giftItems?.map((e: any) => {
        if (e.optionBuy) {
          e.checked = false
        }
        return { ...e, active: true }
      })
      return setListGift(gifts)
    }
  }, [pageDetail, pageType, channel])
  useEffect(() => {
    if (pageDetail && pageType === PageType.PRODUCT) {
      const mergeData = pageDetail?.data?.gifts?.reduce(
        (result: any, item: any) => {
          result.otherOffers = (result.otherOffers || []).concat(
            item.otherOffers
          )
          return result
        },
        {} as any
      )
      const offer = mergeData?.otherOffers?.map((e: any) => {
        return { content: e, active: true }
      })
      if (
        pageDetail?.data?.gifts?.filter(
          (item: { otherOffers: any }) => item.otherOffers
        ).length > 0
      ) {
        return setListOffer(offer)
      }
      return () => {
        setIsOpenComparePopup(false)
      }
    }
  }, [pageDetail, pageType, channel])
  useEffect(() => {
    const handleScroll = () => {
      const scrollPos =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      const element = document.querySelectorAll('section[id]')
      if (element !== null) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        element.forEach(function (section: any) {
          const sectionTop = section?.offsetTop - 64
          const sectionBottom = sectionTop + section?.offsetHeight
          if (scrollPos >= sectionTop - 64 && scrollPos < sectionBottom + 64) {
            document.querySelectorAll('.link-section').forEach(function (link) {
              if (link.getAttribute('data-name') === '#' + section.id) {
                link.classList.add('active')
              } else {
                link.classList.remove('active')
              }
            })
          }
        })
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  useEffect(() => {
    const e =
      pageDetail?.data?.prices?.filter(
        (item: { regionCode: string | null }) => item.regionCode == area
      ).length > 0
    return setCheckSaleArea(e)
  }, [area, router])
  useEffect(() => {
    pixel.fbqEvent('ViewContent')
  }, [])
  const [isOpenDraw, setIsOpenDraw] = useState(false)
  const {
    loading,
    setLoading,
    products,
    properties,
    highLightProperties,
    updateParams,
    activeFilters,
    currentPage,
    setCurrentPage,
    totalProduct,
    getProducts,
    setProducts,
    totalPages,
    clearFilterParams,
    applyFilterParams,
    sortByOptions,
    activeSort,
    activeSortCustom,
  } = useCategory(categoryDetail, pageDetail)
  const { categoryMenu } = useStore()
  const { systemConfig } = useNotification()
  const defaultReviewSummary = [0, 0, 0, 0, 0]
  const reviewSummaryData = useMemo(() => {
    if (pageDetail?.data?.reviewSummary) {
      return pageDetail?.data?.reviewSummary
    }
    return defaultReviewSummary
  }, [pageDetail?.data])

  const stockStatus = useMemo(() => {
    if (
      [
        ProductStockStatus.OUT_OF_STOCK,
        ProductStockStatus.OUT_OF_BUSINESS,
      ].includes(pageDetail?.data?.stockStatus) &&
      !pageDetail?.data?.flashSale &&
      pageType === PageType.PRODUCT
    ) {
      return true
    }
    return false
  }, [pageDetail?.data])
  const fetchMoreProducts = () => {
    setCurrentPage(currentPage + 1)
    setLoading(true)
    getProducts(
      {
        limit: 30,
        categoryDefault: categoryDetail._id,
        currentPage: currentPage + 1,
        sortBy: 'catOrder',
        sortType: 'asc',
        catDisplay: true,
        ...router.query,
      },
      {
        onSuccess: res => {
          setProducts(products.concat(res.data.data))
          setLoading(false)
        },
        onError: () => {
          setLoading(false)
        },
      }
    )
  }
  const targetRef = useRef<HTMLDivElement>(null)
  const [isReadMore, setIsReadMore] = useState(false)
  const [dimensions, setDimensions] = useState(0)

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }
  useIsomorphicLayoutEffect(() => {
    let timeout: NodeJS.Timeout | null = null
    const measureHeight = () => {
      if (targetRef && targetRef.current && categoryDetail?.content) {
        setDimensions(targetRef.current.clientHeight)
      }
    }
    timeout = setTimeout(measureHeight, 400)
    return () => {
      setDimensions(0)
      setIsReadMore(false)
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [categoryDetail?.content])
  const imageGallery = pageDetail?.data?.videoUrl
    ? [
        pageDetail?.data?.videoThumbnail || '',
        ...(pageDetail?.data?.images || []),
      ]
    : pageDetail?.data?.images || []
  if (pageDetail && pageType === PageType.PRODUCT) {
    return (
      <Main
        // bgColor='#E8E8E8'
        meta={
          <Meta
            title={
              pageDetail?.data?.name && getTranslate(pageDetail?.data?.name)
            }
            description={pageShortDescription || productDescription || ''}
            additionalMetaTags={[
              {
                name: pageDetail?.data?.keywords,
                content:
                  pageDetail?.data?.keywords &&
                  getTranslate(pageDetail?.data?.keywords),
              },
            ]}
            imageUrl={pageDetail?.data?.thumbnail}
            canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          />
        }
        page='product-detail'
        pageLayout={PageType.PRODUCT}
      >
        <HeaderProductDetail
          layout={PageType.PRODUCT}
          dataHeader={productName}
          visible={visibleHeader}
          setIsOpenShare={setIsOpenShare}
        />
        <ProductDetailBreadcrumb
          refs={{ reviewRef, descRef, outStandingFeatureRef, specRef }}
          handleClickRef={executeScroll}
        />

        <div className='wrapper'>
          <section className='product_summary'>
            <Gallery
              refs={{ specRef, reviewRef, descRef }}
              handleClickRef={executeScroll}
              isOutOfStock={stockStatus}
              images={imageGallery}
              alt={productName}
              product={pageDetail?.data}
              label={pageDetail?.data}
              video={pageDetail?.data?.videoUrl}
            />
          </section>
          <section
            className='product_price scroll-mt-[60px]'
            id='outStandingFeature'
            ref={outStandingFeatureRef}
          >
            <EntrySummary
              isOpenContact={isOpenContact}
              setIsOpenContact={setIsOpenContact}
              entrySummaryData={pageDetail?.data}
              checkSaleArea={checkSaleArea}
              setListService={setListService}
              listService={listService}
              setListGift={setListGift}
              listGift={listGift}
              setListOffer={setListOffer}
              listOffer={listOffer}
              productCompares={productCompares}
              setProductCompares={setProductCompares}
              setIsOpenComparePopup={setIsOpenComparePopup}
              pickUpInStore={pickUpInStore}
              setPickUpInStore={setPickUpInStore}
              isOutOfStock={stockStatus}
              handleInstallment={addToCart}
              priceWithService={priceWithService}
              setPriceWithService={setPriceWithService}
            />
          </section>
          <section
            ref={descRef}
            className='scroll-mt-[120px] bg-white'
            id='description'
          >
            <Information description={pageDetail?.data?.description} />
          </section>
          <section
            ref={specRef}
            className='scroll-mt-[120px] bg-white'
            id='spec'
          >
            <Specifications specifications={pageDetail?.data?.properties} />
            {pageDetail?.data?.document && (
              <div className='document pb-3 px-3'>
                <div className='flex'>
                  <div className='label w-full max-w-[40%] flex-[40%] pr-3 text-sm font-medium'>
                    Hướng dẫn sử dụng
                  </div>
                  <div className='max-w-[60%] flex-[60%]'>
                    <Link
                      href={pageDetail?.data?.document}
                      className='value text-sm text-primary-base'
                    >
                      Xem hướng dẫn
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </section>
          {pageDetail?.data?.promotions &&
            pageDetail?.data?.promotions.length > 0 && (
              <Promotion promotionData={pageDetail?.data?.promotions} />
            )}
          {pageDetail?.data?.bundledProducts && (
            <BundledProduct
              bundledProducts={pageDetail?.data?.bundledProducts}
              listBundleSelected={listBundleSelected}
              setListBundleSelected={setListBundleSelected}
              priceWithService={
                priceWithService && priceWithService > 0
                  ? priceWithService
                  : pageDetail?.data?.finalPrice
              }
            />
          )}
          <section
            ref={reviewRef}
            className='scroll-mt-[120px] bg-white'
            id='review'
          >
            <ReviewAndRate
              title={getTranslate(pageDetail?.data?.name)}
              productId={pageDetail?.data?._id}
              average={pageDetail?.data?.average}
              reviewSummary={reviewSummaryData}
              setVisibleHeader={setVisibleHeader}
            />
          </section>
          {pageDetail?.data?.relatedProducts &&
            pageDetail?.data?.relatedProducts.length > 0 && (
              <RelatedProduct
                relatedProductData={orderBy(
                  pageDetail?.data?.relatedProducts,
                  'order',
                  'asc'
                )}
              />
            )}
        </div>

        {/* Footer product detail */}
        <FooterProductDetail
          setIsOpenContact={setIsOpenContact}
          handleAddToCart={addToCart}
          addToCartData={pageDetail?.data}
          cartLoading={cartLoading}
          checkSaleArea={checkSaleArea}
          listService={listService}
          listGift={listGift}
          listOffer={listOffer}
          pickUpInStore={pickUpInStore}
          setPickUpInStore={setPickUpInStore}
          isPreOrder={isPreOrder}
          listBundleSelected={listBundleSelected}
          handleAddBundleToCart={addBundleToCart}
        />
        {/* Popup comming soon */}
        <PopupShare
          setIsOpenShare={setIsOpenShare}
          isOpenShare={isOpenShare}
          data={pageDetail?.data}
        />
      </Main>
    )
  }

  if (pageDetail && pageType === PageType.PAGE_CMS) {
    return (
      <Main
        meta={
          <Meta
            title={getTranslate(pageDetail?.data?.title)}
            description={getTranslate(pageDetail?.data?.description)}
            additionalMetaTags={[
              {
                name: pageDetail?.data?.keywords,
                content:
                  pageDetail?.data?.keywords &&
                  getTranslate(pageDetail?.data?.keywords),
              },
            ]}
            imageUrl={pageDetail?.data?.thumbnail}
            canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          />
        }
        dataHeader={getTranslate(pageDetail?.data?.title)}
        pageLayout=''
      >
        <section className='pageDetail min-h-[calc(100svh-60px)] pb-[80px] mt-3 bg-white container pt-4'>
          <div
            dangerouslySetInnerHTML={{
              __html: getTranslate(pageDetail.content),
            }}
          ></div>
        </section>
      </Main>
    )
  }
  if (pageDetail && pageType === PageType.POST) {
    return <PostDetail postDetail={pageDetail?.data} hideMenu={hideMenu} />
  }

  if (categoryDetail) {
    return (
      <Main
        meta={
          <Meta
            title={getTranslate(categoryDetail.name)}
            description={getTranslate(categoryDetail.description)}
            additionalMetaTags={[
              {
                name: pageDetail?.data?.keywords,
                content:
                  pageDetail?.data?.keywords &&
                  getTranslate(pageDetail?.data?.keywords),
              },
            ]}
            imageUrl={pageDetail?.data?.thumbnail}
            canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          />
        }
        pageLayout={PageType.CATEGORY}
        bgColor='#E8E8E8'
        showFooter={true}
      >
        <HeaderCategory
          applyFilterParams={applyFilterParams}
          clearFilterParams={clearFilterParams}
          properties={properties}
          activeFilters={activeFilters}
          updateParams={updateParams}
          setIsOpenDraw={setIsOpenDraw}
          isOpenDraw={isOpenDraw}
          categoryMenu={categoryMenu}
          categoryDetail={categoryDetail}
          sortOptions={sortByOptions}
          activeSort={activeSort}
          activeSortCustom={activeSortCustom}
        />
        <div className='category-wrapper flex flex-wrap min-h-[calc(100svh-112px)] flex-col items-start justify-start'>
          {categoryDetail?.productCatBanners && (
            <BannerProductListing data={categoryDetail.productCatBanners} />
          )}
          {categoryDetail && categoryDetail?.children?.length > 0 && (
            <ChildrenCategory data={categoryDetail?.children} />
          )}
          <section className='topFilters w-full overflow-hidden'>
            <div className='container'>
              <h1 className='text-titleSection text-dark-900 mb-2'>
                {getTranslate(categoryDetail.name)}{' '}
                <span className='surfix'>dành cho bạn</span>
              </h1>
            </div>
            {highLightProperties &&
              highLightProperties.map((e: Property) => (
                <FilterHighlight
                  key={`e-${e._id}`}
                  filterGroup={e}
                  activeFilters={activeFilters}
                  onChange={updateParams}
                />
              ))}
            <div className='container mb-2'>
              <CategorySort
                sortOptions={sortByOptions}
                onChange={updateParams}
                activeSort={activeSort}
                activeSortCustom={activeSortCustom}
              />
            </div>
          </section>
          <section className='container mt-1 flex flex-wrap h-full w-full '>
            <div className='cateProductList w-full'>
              {loading && (
                <div className='products grid grid-cols-2 gap-3 pb-[120px]'>
                  {[...new Array(8)].map(() => (
                    <ProductCardSkeleton key={uuidv4()} />
                  ))}
                </div>
              )}
              {products && products.length > 0 ? (
                <>
                  <div className='products grid grid-cols-2 gap-2 mb-[40px]'>
                    {products?.map((product, index) => (
                      <ProductCard
                        layout={2}
                        product={product}
                        key={product._id + index + 'plist'}
                        type='list'
                      />
                    ))}
                  </div>
                  {currentPage < totalPages && (
                    <div
                      className='loadMore relative mx-auto mt-6 flex w-max min-w-[180px] cursor-pointer items-center justify-center gap-2 rounded border border-zinc-300 px-4 py-2'
                      onClick={fetchMoreProducts}
                    >
                      {loading ? (
                        <Loading />
                      ) : (
                        <>
                          <span className='text-center text-sm font-normal leading-normal text-primary-second'>
                            Xem thêm {totalProduct - products.length}{' '}
                            <span className='lowercase'>
                              {getTranslate(categoryDetail.name)}
                            </span>
                          </span>
                          <span className='origin-top-left'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width={13}
                              height={13}
                              viewBox='0 0 17 17'
                              fill='none'
                            >
                              <path
                                d='M15.0978 6.86128C15.3017 6.69154 15.4299 6.44774 15.4541 6.1835C15.4783 5.91926 15.3965 5.65623 15.2268 5.45228C15.057 5.24833 14.8132 5.12016 14.549 5.09597C14.2847 5.07177 14.0217 5.15354 13.8178 5.32328L8.45777 9.79228L3.09777 5.32328C2.99678 5.23923 2.88023 5.1759 2.75477 5.1369C2.6293 5.0979 2.49739 5.08399 2.36655 5.09597C2.23571 5.10794 2.10852 5.14558 1.99222 5.20671C1.87593 5.26785 1.77281 5.35129 1.68877 5.45228C1.51903 5.65623 1.43726 5.91926 1.46146 6.1835C1.48565 6.44773 1.61382 6.69154 1.81777 6.86128L7.81777 11.8613C7.99746 12.0109 8.22391 12.0929 8.45777 12.0929C8.69162 12.0929 8.91808 12.0109 9.09777 11.8613L15.0978 6.86128Z'
                                fill='#FF424E'
                              />
                            </svg>
                          </span>
                        </>
                      )}
                    </div>
                  )}
                </>
              ) : (
                ''
              )}
              {products && products?.length == 0 && !loading && (
                <NotFoundItem
                  label={`${
                    systemConfig?.websiteBrandName || ''
                  } chưa có sản phẩm phù hợp với yêu cầu của bạn`}
                />
              )}
            </div>
          </section>
          {categoryDetail.content && categoryDetail.content.vi !== '' && (
            <section
              className={`contentCategory container relative mb-[180px] mt-8 flex flex-wrap`}
            >
              <div
                className={`content flex flex-col items-start overflow-hidden transition-height duration-300 ease-in-out ${
                  isReadMore ? 'max-h-full' : 'max-h-[100px]'
                }`}
              >
                <div
                  ref={targetRef}
                  dangerouslySetInnerHTML={{
                    __html: getTranslate(categoryDetail?.content),
                  }}
                />
              </div>
              {dimensions < 100 ? (
                ''
              ) : (
                <div
                  className={`absolute -bottom-[60px] left-0 z-50 flex h-[100px] w-full items-end ${
                    isReadMore
                      ? ''
                      : 'bg-gradient-to-b from-white-400/0 to-white'
                  }`}
                >
                  <button
                    className='readMore z-50 mx-auto mb-0 mt-auto flex w-[120px] cursor-pointer flex-col flex-wrap items-center justify-center px-2 pt-3'
                    type='button'
                    onClick={toggleReadMore}
                  >
                    <span className='text-center text-sm font-normal leading-normal text-primary-base'>
                      {isReadMore ? 'Thu gọn' : 'Xem thêm'}{' '}
                    </span>
                    <span className={`${isReadMore ? 'rotate-180' : ''}`}>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width={18}
                        height={19}
                        viewBox='0 0 18 19'
                        fill='none'
                      >
                        <path
                          d='M8.99999 14.2383C8.8522 14.2385 8.70584 14.2094 8.56932 14.1529C8.43279 14.0963 8.30879 14.0133 8.20444 13.9087L1.45444 7.15867C1.24606 6.94715 1.12974 6.66181 1.13087 6.36489C1.13199 6.06796 1.25046 5.78352 1.46043 5.57358C1.67041 5.36363 1.95488 5.24522 2.25181 5.24415C2.54873 5.24308 2.83404 5.35944 3.04553 5.56786L8.99999 11.5222L14.9544 5.56786C15.1659 5.35944 15.4512 5.24308 15.7482 5.24415C16.0451 5.24522 16.3296 5.36363 16.5395 5.57358C16.7495 5.78352 16.868 6.06796 16.8691 6.36489C16.8702 6.66181 16.7539 6.94715 16.5455 7.15867L9.79553 13.9087C9.69118 14.0133 9.56718 14.0963 9.43066 14.1529C9.29413 14.2094 9.14777 14.2385 8.99999 14.2383Z'
                          fill='#00C1D5'
                          fillOpacity='0.8'
                        />
                        <path
                          d='M8.99999 8.89452C8.8522 8.89471 8.70584 8.86569 8.56932 8.80912C8.43279 8.75256 8.30879 8.66957 8.20444 8.56492L2.86069 3.22117C2.65231 3.00965 2.53599 2.72432 2.53712 2.42739C2.53824 2.13046 2.65671 1.84602 2.86668 1.63608C3.07666 1.42613 3.36113 1.30772 3.65806 1.30665C3.95498 1.30558 4.24029 1.42194 4.45178 1.63036L8.99999 6.17843L13.5482 1.63036C13.7597 1.42194 14.045 1.30558 14.3419 1.30665C14.6388 1.30772 14.9233 1.42613 15.1333 1.63608C15.3433 1.84602 15.4617 2.13046 15.4629 2.42739C15.464 2.72432 15.3477 3.00965 15.1393 3.22117L9.79553 8.56492C9.69119 8.66957 9.56718 8.75256 9.43066 8.80912C9.29413 8.86569 9.14777 8.89471 8.99999 8.89452Z'
                          fill='#00C1D5'
                          fillOpacity='0.8'
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              )}
            </section>
          )}
        </div>
      </Main>
    )
  }
}
export default DynamicPage

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res, query } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )

  let categoryDetail
  const { slug, hideMenu } = query
  if (!slug) {
    return {
      notFound: true,
    }
  }
  const path = slug[slug.length - 1].split('.')
  if (path.length > 1 && path[1].indexOf('c') > -1) {
    categoryDetail = await getCategory(path[0], query as QueryParam)
    if (!categoryDetail) {
      return {
        notFound: true,
      }
    }
  } else {
    const pathMapping =
      Array.isArray(slug) && slug.length > 1 ? slug.join('/') : slug
    const path = await getPath(pathMapping as string)
    if (path) {
      return {
        redirect: {
          permanent: true,
          source: `/${path.path}`,
          destination: `/${path.slug || path.url}`,
        },
      }
    }
  }

  const params = {
    ...query,
    limit: 30,
    sortBy: query?.sortBy ? query?.sortBy : 'catOrder',
    sortType: query?.sortType ? query?.sortType : 'asc',
    catDisplay: true,
    ...{ catId: categoryDetail?._id },
  }

  const [
    menus,
    regions,
    categoryMenu,
    pageDetail,
    systemConfig,
    keywords,
    bottomMenu,
  ] = await Promise.all([
    getMenus(),
    getSaleRegion(),
    getCategoryMenu(),
    getPageDetail(path, params),
    getConfig(),
    getKeywordFooter(),
    getBottomMenu(),
  ])

  if (!pageDetail || !pageDetail.data) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      menus,
      regions,
      language,
      messages,
      categoryMenu,
      systemConfig,
      pageDetail,
      pageType: getPageTypeFromPath(path),
      categoryDetail: categoryDetail || null,
      hideMenu: hideMenu || null,
      token: token || null,
      keywords,
      bottomMenu,
    },
  }
}
